<template>
    <div class="page-navbar">
        <div class="container">
            <nav class="navbar navbar-expand-md">
                <button class="navbar-toggler" v-if="isAuthenticated" type="button"
                        @click="display.userMenu=!display.userMenu">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <!-- Brand -->
                <router-link class="navbar-brand" :to="{name:'home'}"/>
                <!-- Mobile: start -->
                <ul v-if="enable.cart" class="navbar-nav ms-md-auto d-md-none flex-row">
                    <li class="nav-item">
                        <router-link class="nav-link navbar-link-cart" :to="{name:'order.submit'}">
                            <span v-if="cartLoading" class="icon-spinner animate-spin"></span>
                            <span v-else class="icon-basket"></span>
                            <span v-if="0 < cartTotal" class="badge badge-pill bg-danger">{{cartTotal}}</span>
                        </router-link>
                    </li>
                </ul>
                <!-- Mobile: end -->
                <div class="collapse navbar-collapse" v-if="isAuthenticated" :class="{show:display.userMenu}">
                    <ul class="navbar-nav navbar-nav-bordered ms-md-auto">
                        <!-- Dashboard -->
                        <li v-if="enable.dashboard" class="nav-item">
                            <a :href="dashboardUrl" class="nav-link">
                                <span class="nav-link-text">{{t('dashboard')}}</span>
                            </a>
                        </li>
                        <!-- Support Widget -->
                        <li v-if="widget_displayWidgetButton" class="nav-item">
                            <a href="#" class="nav-link" role="button" :data-widget-trigger="widget_optionsJson">
                                <span class="nav-link-text">{{t('support')}}</span>
                            </a>
                        </li>
                        <!-- Cart -->
                        <li v-if="enable.cart" class="nav-item d-none d-md-block">
                            <router-link class="nav-link navbar-link-cart" :to="{name:'order.submit'}">
                                <span v-if="cartLoading" class="icon-spinner animate-spin"></span>
                                <span v-else class="icon-basket"></span>
                                <span class="badge badge-pill bg-danger" v-if=" 0 <cartTotal">{{cartTotal}}</span>
                            </router-link>
                        </li>
                        <!-- User -->
                        <li class="nav-item d-none d-md-block dropdown">
                            <!-- Tablet, Desktop -->
                            <a href="#" class="nav-link" role="button" v-dropdown.desktopUserMenu>
                                <span class="icon-user"></span>
                                <span class="nav-link-text user-name">{{userName}}</span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" ref="desktopUserMenu">
                                <router-link v-if="enable.profile.edit" class="dropdown-item"
                                             :to="{name:'quiz', query: {reset: true}}">
                                    {{$t('navigation.user.profile.edit')}}
                                </router-link>
                                <router-link v-if="enable.approvals.approvals" class="dropdown-item"
                                             :to="{name:'approvals'}">
                                    {{$t('navigation.approvals.approvals')}}
                                </router-link>
                                <router-link v-if="enable.approvals.delegate" class="dropdown-item"
                                             :to="{name:'approvals.delegate'}">
                                    {{$t('navigation.approvals.delegates')}}
                                </router-link>
                                <router-link v-if="enable.impersonation" class="dropdown-item"
                                             :to="{name:'impersonation'}">
                                    {{$t('navigation.impersonation')}}
                                </router-link>
                                <router-link class="dropdown-item" :to="{name:'auth.logout'}">
                                    {{$t('navigation.logout')}}
                                </router-link>
                            </div>
                        </li>
                        <!-- Mobile -->
                        <li class="nav-item d-md-none">
                            <router-link v-if="enable.profile.edit" class="nav-link"
                                         :to="{name:'quiz', query: {reset: true}}">
                                {{$t('navigation.user.profile.edit')}}
                            </router-link>
                            <router-link v-if="enable.approvals.approvals" class="nav-link" :to="{name:'approvals'}">
                                {{$t('navigation.approvals.approvals')}}
                            </router-link>
                            <router-link v-if="enable.approvals.delegate" class="nav-link"
                                         :to="{name:'approvals.delegate'}">
                                {{$t('navigation.approvals.delegates')}}
                            </router-link>
                            <router-link v-if="enable.impersonation" class="nav-link" :to="{name:'impersonation'}">
                                {{$t('navigation.impersonation')}}
                            </router-link>
                            <router-link class="nav-link" :to="{name:'auth.logout'}">{{$t('navigation.logout')}}
                            </router-link>
                        </li>
                        <!-- Language -->
                        <li v-if="1 < languages.length" class="nav-item d-md-none">
                            <!-- Mobile -->
                            <a href="#" class="nav-link" role="button" v-dropdown.languageDropdownMenu>
                                <span class="nav-link-text language-name">{{language.name}}</span>
                                <span class="icon-down-dir"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right dropdown-menu-collapsed"
                                 ref="languageDropdownMenu">
                                <a href="#" role="button" class="dropdown-item" v-for="lang in languages"
                                   :key="lang.value"
                                   :class="{active:lang.value==language.value}"
                                   @click.prevent="setLanguage(lang)">
                                    <span class="nav-link-text">{{lang.name}}</span>
                                </a>
                            </div>
                        </li>
                        <li v-if="1 < languages.length" class="nav-item d-none d-md-block dropdown">
                            <!-- Tablet, Desktop -->
                            <a href="#" class="nav-link" role="button" v-dropdown.languageDropdownMenuDesktop>
                                <span class="language-name nav-link-text">{{language.name}}</span>
                                <span class="icon-down-dir"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" ref="languageDropdownMenuDesktop">
                                <a href="#" role="button" class="dropdown-item" v-for="lang in languages"
                                   :key="lang.value"
                                   :class="{active:lang.value==language.value}"
                                   @click.prevent="setLanguage(lang)">
                                    {{lang.name}}
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
                <ul v-else-if="1 < languages.length || widget_displayWidgetButton" class="navbar-nav ms-auto">
                    <!-- Dashboard -->
                    <li v-if="enable.dashboard" class="nav-item">
                        <a :href="dashboardUrl" class="nav-link">
                            <span class="nav-link-text">{{t('dashboard')}}</span>
                        </a>
                    </li>
                    <!-- Support Widget -->
                    <li v-if="widget_displayWidgetButton" class="nav-item">
                        <a href="#" class="nav-link" role="button" :data-widget-trigger="widget_optionsJson">
                            <span class="nav-link-text">{{t('support')}}</span>
                        </a>
                    </li>
                    <!-- Language -->
                    <li v-if="1 < languages.length" class="nav-item dropdown">
                        <a href="#" class="nav-link" role="button" v-dropdown.languageDropdownMenu>
                            <span class="nav-link-text language-name">{{language.name}}</span>
                            <span class="icon-down-dir"></span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right position-absolute" ref="languageDropdownMenu">
                            <a href="#" role="button" class="dropdown-item" v-for="lang in languages"
                               :key="lang.value"
                               :class="{active:lang.value==language.value}"
                               @click.prevent="setLanguage(lang)">
                                {{lang.name}}
                            </a>
                        </div>
                    </li>
                </ul>
            </nav>
        </div>
        <a v-if="widget_optionsFlowJson"
           class="d-none"
           :data-widget-trigger="widget_optionsFlowJson"
           ref="widget-flow"></a>
    </div>
</template>

<script>

    import {mapGetters} from "vuex"

    import mixin_widget from "@mixins_widget";
    import mixin_view from "@/mixins/view";
    import {PERMISSIONS, USER_MENU_DISPLAY_EDIT_PROFILE} from "@/constants";

    export default {
        name: "PageNavbar",
        mixins: [mixin_widget, mixin_view],
        data() {

            return {
                t_path: "navbar",
                dashboardUrl: process.env.VUE_APP_DASHBOARD_URL,
                display: {
                    userMenu: false
                },
                widgetOptionsFlow: null
            };
        },
        computed: {
            ...mapGetters({
                isAuthenticated: "user/isAuthenticated",
                cartTotal: "user/cart/total",
                userName: "user/profile/firstName",
                languages: "i18n/languages",
                language: "i18n/language",
                cartLoading: "user/cart/loading"
            }),
            isImpersonated() {

                return null !== this.$store.getters["user/impersonatorToken"];
            },
            enable() {

                return {
                    dashboard: this.$store.getters["user/permissions/hasPermissionAccess"](PERMISSIONS.DASHBOARD),
                    cart: this.$store.getters["user/permissions/hasPermissionAccess"](PERMISSIONS.EMPLOYEE),
                    profile: {
                        edit: USER_MENU_DISPLAY_EDIT_PROFILE
                            && (
                                false === this.$store.getters["user/permissions/hasRestriction"](PERMISSIONS.EMPLOYEE)
                                || false !== this.$store.getters["user/permissions/getRestriction"](PERMISSIONS.EMPLOYEE).isUserTypeAccessAllowed
                            )
                    },
                    approvals: {
                        delegate: !this.isImpersonated && this.$store.getters["config/user/delegate/enabled"],
                        approvals: this.$store.getters["user/permissions/hasPermissionAccess"](PERMISSIONS.MANAGER)
                    },
                    impersonation: !this.isImpersonated
                        && this.$store.getters["user/permissions/hasPermissionAccess"](PERMISSIONS.IMPERSONATE_USER)
                        && !this.$store.getters["user/permissions/hasRestriction"](PERMISSIONS.EMPLOYEE)
                };
            }
        },
        methods: {
            setLanguage(language) {

                this.$i18n.locale = language.value;

                this.$store.dispatch("i18n/setLanguage", language);
                this.$store.dispatch("user/setLanguage", language.value);

                this.view_setTitle();

                if (this.widget_displayWidgetButton) {

                    this.widget_init();
                }
            },
            processWidgetFlow() {
                if (this.widget_optionsFlowJson) {

                    setTimeout(
                        () => this.$refs["widget-flow"].dispatchEvent(new Event("click")),
                        1000
                    )
                }
            }
        },
        watch: {
            $route(to) {

                this.display.userMenu = false;
            }
        },
        mounted() {

            this.processWidgetFlow()
        }
    }
</script>